import { green } from '@ant-design/colors';
import { CheckCircleOutlined } from "@ant-design/icons";
import { notification } from "antd";
import {
  BackbuttonComponent,
  ContainerComponent,
} from "../../../components";
import { useQuery } from "../../../hooks";
import { UseCaseFormPartial } from "../../../partials/use-case-form.partial";
import { useParams } from "react-router-dom";

export const EditUseCaseView = () => {
  const [api, contextHolder] = notification.useNotification();
  const { useCaseId } = useParams();
  const { data, loading, execute } = useQuery({
    url: `/usecase/${useCaseId}`,
    options: { method: "GET" },
  });

  return loading || !data ? null : (
    <>
      {contextHolder}
      <ContainerComponent style={{ width: "100%", justifyContent: "start" }}>
        <BackbuttonComponent style={{ marginBottom: 16, alignSelf: "start" }} />
        <UseCaseFormPartial
          method={"PUT"}
          onSaved={(result) => {
            api.open({
              message: <span style={{ color: "#ffffff" }}>¡Éxito!</span>,
              description: (
                <span style={{ color: "#ffffff" }}>
                  El caso de uso se actualizó correctamente.
                </span>
              ),
              icon: (<CheckCircleOutlined />),
              style: {
                backgroundColor: green[6],
                border: "1px solid #237804",
                color: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                padding: "16px",
              },
              duration: 3, // Duración de la notificación en segundos
            });
  
            setTimeout(() => {
              execute();
            }, 3000);
            //execute();
          }}
          initialValues={{
            ...data,
            successStories: data.successStories || [],
          }}
        />
      </ContainerComponent>
    </>
  );
};

export const EditUseCaseViewRoute = ({ useCaseId }) =>
  `/usecases/${useCaseId}/edit`;
